export default __webpack_public_path__ + "static/specific-mtg-cube-power-level-9c3f18c77e233176fc8f45a249882a54.png";